export enum WorkflowStatus {
  IN_PROGRESS = 'inProgress',
  IN_REVIEW = 'inReview',
  APPROVED = 'approved',
}
